import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
//utils
import queries from '../../../utils/queries';
import 'moment/locale/es';
var moment = require('moment');

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return (
    <option dato1={props.elemento.consecProducto?props.elemento.consecProducto:0} 
    dato2={props.elemento.consecServicio?props.elemento.consecServicio:0} 
    dato3={props.elemento.consecPrograma?props.elemento.consecPrograma:0} 
    dato4={props.elemento.codEmpresa?props.elemento.codEmpresa:""}>{props.elemento.descrEmpresa}</option>
  ) 
};

const ListaEmp = ({list, handleLista}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={handleLista}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleConNivel1 = props => {
  return (
    <option dato1={props.elemento.ciudad?props.elemento.ciudad:""} dato2={props.elemento.cargo?props.elemento.cargo:""} dato3={props.elemento.email?props.elemento.email:""} dato4={props.elemento.telefono?props.elemento.telefono:""} value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaCon = ({list, handleLista}) => {
  const Nivel3Detalle = list.map((elemento, _id) => <DetalleConNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="nombreContacto" id="miLista3" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel3Detalle}
      </select>
    </div>
  )
};


  class AddTraslado2 extends React.Component{
    state={argsAdd: {}}

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    let file = "", archivoRecibido = ""
    if(ev.target.files[0]){
      file = ev.target.files[0]
      archivoRecibido = ev.target.files[0].name
    }
    argsAdd['archivoRecibido'] = archivoRecibido
    argsAdd['file'] = file
    this.setState({argsAdd})
  }

  render(){
    const {argsAdd} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let args = Object.assign({}, this.props.args, argsAdd)

    let lista2 = []
    if(this.props.allUsuariosRtesExt.allUsuariosRtes){
      this.props.allUsuariosRtesExt.refetch()
      lista2 = this.props.allUsuariosRtesExt.allUsuariosRtes
    }
    let listCon=[]
    listCon = lista2.filter(elemento => elemento.descrEmpresa===args.descrEmpresa)

  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Traslado nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}>
          <div className="ui four column stackable grid">
            <div className="row container">
              <div className="column" width="30%">
                <Form.Field>
                  <label style={this.props.styles.label}>Empresa</label>
                  <ListaEmp list={this.props.list} handleLista={this.props.handleLista} />
                </Form.Field>
              </div>
              <div className="column" width="25%">
                <Form.Field>
                  <label style={this.props.styles.label}>Contacto</label>
                  <ListaCon list={listCon} handleLista={this.props.handleLista2} />
                </Form.Field>                
              </div>
              <div className="column" width="15%">  
                <Form.Field>                
                  <label style={this.props.styles.label}># Orden del cliente</label>
                  <Form.Input autoComplete="off" name="ordenCompraCliente" id="ordenCompraCliente" onChange={this.props.handleChange} placeholder='# Orden del cliente' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'ordenCompraCliente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
              <div className="column" width="30%">
                  <Form.Field>
                    <label style={this.props.styles.label}>
                      Archivo de solicitud del cliente...&nbsp;&nbsp;
                    </label>
                    <input id="file" name="file" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={this.handleChange}></input>
                  </Form.Field>  
                </div>
            </div>
          </div>
          <div className="row container">              
            <div className="column" width="100%">  
              <Form.Field>                
                <label style={this.props.styles.label}>Observaciones</label>
                <textarea name="observaciones" id="observaciones" cols="40" rows="3" onChange={this.props.handleChange}></textarea>                
              </Form.Field>
            </div>
          </div>
          <div className="row container">
            <div className="column" width="100%">                
              <Button style={this.props.styles.confirmar} type='submit' fluid>
                AGREGAR
              </Button>
            </div>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </div>
        </Form>
      </div>
    </div>
  )
  }
}

// export default AddProcEjec2
export default compose(
  graphql(queries.mutation.fecha, {name:'fecha'}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: {$ne: 'XXXXXXX'}}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtesExt',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Externo'}}]`}}}}),


  )(AddTraslado2)